import { Q as getContext, T as spread_attributes, V as clsx$1, W as escape_html, P as pop, N as push, O as setContext, X as attr_class, Y as bind_props, Z as spread_props, _ as attr } from "../../chunks/index.js";
import clsx from "clsx";
import { g as getTheme, t as toolbarButton, n as navbarContainer, a as navbar, b as navbarBrand, c as navbarLi, d as navbarUl, e as navbarHamburger } from "../../chunks/theme.js";
function html(value) {
  var html2 = String(value);
  var open = "<!---->";
  return open + html2 + "<!---->";
}
function cubic_out(t) {
  const f = t - 1;
  return f * f * f + 1;
}
function slide(node, { delay = 0, duration = 400, easing = cubic_out, axis = "y" } = {}) {
  const style = getComputedStyle(node);
  const opacity = +style.opacity;
  const primary_property = axis === "y" ? "height" : "width";
  const primary_property_value = parseFloat(style[primary_property]);
  const secondary_properties = axis === "y" ? ["top", "bottom"] : ["left", "right"];
  const capitalized_secondary_properties = secondary_properties.map(
    (e) => (
      /** @type {'Left' | 'Right' | 'Top' | 'Bottom'} */
      `${e[0].toUpperCase()}${e.slice(1)}`
    )
  );
  const padding_start_value = parseFloat(style[`padding${capitalized_secondary_properties[0]}`]);
  const padding_end_value = parseFloat(style[`padding${capitalized_secondary_properties[1]}`]);
  const margin_start_value = parseFloat(style[`margin${capitalized_secondary_properties[0]}`]);
  const margin_end_value = parseFloat(style[`margin${capitalized_secondary_properties[1]}`]);
  const border_width_start_value = parseFloat(
    style[`border${capitalized_secondary_properties[0]}Width`]
  );
  const border_width_end_value = parseFloat(
    style[`border${capitalized_secondary_properties[1]}Width`]
  );
  return {
    delay,
    duration,
    easing,
    css: (t) => `overflow: hidden;opacity: ${Math.min(t * 20, 1) * opacity};${primary_property}: ${t * primary_property_value}px;padding-${secondary_properties[0]}: ${t * padding_start_value}px;padding-${secondary_properties[1]}: ${t * padding_end_value}px;margin-${secondary_properties[0]}: ${t * margin_start_value}px;margin-${secondary_properties[1]}: ${t * margin_end_value}px;border-${secondary_properties[0]}-width: ${t * border_width_start_value}px;border-${secondary_properties[1]}-width: ${t * border_width_end_value}px;min-${primary_property}: 0`
  };
}
function ToolbarButton($$payload, $$props) {
  push();
  const background = getContext("background");
  let {
    children,
    color,
    name,
    "aria-label": ariaLabel,
    size,
    class: className,
    $$slots,
    $$events,
    ...restProps
  } = $$props;
  const theme = getTheme("toolbarButton");
  const buttonCls = toolbarButton({
    color,
    size,
    background: !!background,
    class: clsx(theme, className)
  });
  if (restProps.href === void 0) {
    $$payload.out += "<!--[-->";
    $$payload.out += `<button${spread_attributes(
      {
        type: "button",
        ...restProps,
        class: clsx$1(buttonCls),
        "aria-label": ariaLabel ?? name
      }
    )}>`;
    if (name) {
      $$payload.out += "<!--[-->";
      $$payload.out += `<span class="sr-only">${escape_html(name)}</span>`;
    } else {
      $$payload.out += "<!--[!-->";
    }
    $$payload.out += `<!--]--> `;
    children?.($$payload);
    $$payload.out += `<!----></button>`;
  } else {
    $$payload.out += "<!--[!-->";
    $$payload.out += `<a${spread_attributes(
      {
        ...restProps,
        class: clsx$1(buttonCls),
        "aria-label": ariaLabel ?? name
      }
    )}>`;
    if (name) {
      $$payload.out += "<!--[-->";
      $$payload.out += `<span class="sr-only">${escape_html(name)}</span>`;
    } else {
      $$payload.out += "<!--[!-->";
    }
    $$payload.out += `<!--]--> `;
    children?.($$payload);
    $$payload.out += `<!----></a>`;
  }
  $$payload.out += `<!--]-->`;
  pop();
}
function NavContainer($$payload, $$props) {
  push();
  let {
    children,
    fluid,
    class: clasName,
    $$slots,
    $$events,
    ...restProps
  } = $$props;
  const theme = getTheme("navbarContainer");
  $$payload.out += `<div${spread_attributes(
    {
      ...restProps,
      class: clsx$1(navbarContainer({ fluid, class: clsx(theme, clasName) }))
    }
  )}>`;
  children?.($$payload);
  $$payload.out += `<!----></div>`;
  pop();
}
function Navbar($$payload, $$props) {
  push();
  let {
    children,
    fluid,
    navContainerClass,
    class: className,
    closeOnClickOutside = true,
    breakpoint = "md",
    $$slots,
    $$events,
    ...restProps
  } = $$props;
  const theme = getTheme("navbar");
  let navState = { hidden: true };
  setContext("navState", navState);
  setContext("breakpoint", breakpoint);
  let toggle = () => {
    navState.hidden = !navState.hidden;
  };
  $$payload.out += `<nav><div${spread_attributes(
    {
      ...restProps,
      class: clsx$1(navbar({ class: clsx(theme, className) }))
    }
  )}>`;
  NavContainer($$payload, {
    fluid,
    class: clsx(navContainerClass),
    children: ($$payload2) => {
      children($$payload2, { hidden: navState.hidden, toggle, NavContainer });
      $$payload2.out += `<!---->`;
    },
    $$slots: { default: true }
  });
  $$payload.out += `<!----></div></nav>`;
  pop();
}
function NavBrand($$payload, $$props) {
  push();
  let { children, class: className, $$slots, $$events, ...restProps } = $$props;
  const theme = getTheme("navbarBrand");
  $$payload.out += `<a${spread_attributes(
    {
      ...restProps,
      class: clsx$1(navbarBrand({ class: clsx(theme, className) }))
    }
  )}>`;
  children?.($$payload);
  $$payload.out += `<!----></a>`;
  pop();
}
function NavLi($$payload, $$props) {
  push();
  let navState = getContext("navState");
  let navBreakpoint = getContext("breakpoint");
  let {
    children,
    onclick,
    activeClass,
    nonActiveClass,
    class: className,
    $$slots,
    $$events,
    ...restProps
  } = $$props;
  const theme = getTheme("navbarLi");
  let active = navState.activeUrl ? restProps.href === navState.activeUrl : false;
  let liClass = navbarLi({
    breakpoint: navBreakpoint,
    hidden: navState.hidden,
    class: clsx(
      active ? activeClass ?? navState.activeClass : nonActiveClass ?? navState.nonActiveClass,
      theme,
      className
    )
  });
  $$payload.out += `<li>`;
  if (restProps.href === void 0) {
    $$payload.out += "<!--[-->";
    $$payload.out += `<button${spread_attributes({ role: "presentation", ...restProps, class: clsx$1(liClass) })}>`;
    children?.($$payload);
    $$payload.out += `<!----></button>`;
  } else {
    $$payload.out += "<!--[!-->";
    $$payload.out += `<a${spread_attributes({ ...restProps, class: clsx$1(liClass) })}>`;
    children?.($$payload);
    $$payload.out += `<!----></a>`;
  }
  $$payload.out += `<!--]--></li>`;
  pop();
}
function NavUl($$payload, $$props) {
  push();
  let navState = getContext("navState");
  let navBreakpoint = getContext("breakpoint");
  let {
    children,
    activeUrl = void 0,
    ulClass,
    slideParams,
    transition = slide,
    transitionParams,
    activeClass,
    nonActiveClass,
    respectMotionPreference = true,
    class: clasName,
    classes,
    $$slots,
    $$events,
    ...restProps
  } = $$props;
  const styling = classes ?? { ul: ulClass };
  const theme = getTheme("navbarUl");
  let hidden = navState.hidden ?? true;
  let { base, ul, active, nonActive } = navbarUl({ hidden, breakpoint: navBreakpoint });
  let divCls = base({ class: clsx(theme?.base, clasName) });
  let ulCls = ul({ class: clsx(theme?.ul, styling.ul) });
  if (!hidden) {
    $$payload.out += "<!--[-->";
    $$payload.out += `<div${spread_attributes({ ...restProps, class: clsx$1(divCls) })}><ul${attr_class(clsx$1(ulCls))}>`;
    children?.($$payload);
    $$payload.out += `<!----></ul></div>`;
  } else {
    $$payload.out += "<!--[!-->";
    $$payload.out += `<div${spread_attributes({ ...restProps, class: clsx$1(divCls) })}><ul${attr_class(clsx$1(ulCls))}>`;
    children?.($$payload);
    $$payload.out += `<!----></ul></div>`;
  }
  $$payload.out += `<!--]-->`;
  bind_props($$props, { activeUrl });
  pop();
}
function Menu($$payload, $$props) {
  push();
  let {
    size = "24",
    color = "currentColor",
    variation = "outline",
    ariaLabel = "bars 3",
    class: className,
    $$slots,
    $$events,
    ...restProps
  } = $$props;
  let viewBox = "0 0 24 24";
  let svgpath = "";
  $$payload.out += `<svg${spread_attributes(
    {
      xmlns: "http://www.w3.org/2000/svg",
      role: "button",
      tabindex: "0",
      width: size,
      height: size,
      class: clsx$1(clsx(className)),
      ...restProps,
      "aria-label": ariaLabel,
      fill: "none",
      viewBox,
      "stroke-width": "2"
    },
    null,
    void 0,
    void 0,
    3
  )}>${html(svgpath)}</svg>`;
  pop();
}
function NavHamburger($$payload, $$props) {
  push();
  let {
    children,
    onclick,
    menuClass,
    class: className,
    classes,
    name = "Open main menu",
    $$slots,
    $$events,
    ...restProps
  } = $$props;
  const styling = classes ?? { menu: menuClass };
  const theme = getTheme("navbarHamburger");
  const navState = getContext("navState");
  const navBreakpoint = getContext("breakpoint");
  const { base, menu } = navbarHamburger({ breakpoint: navBreakpoint });
  const toggle = (ev) => {
    navState.hidden = !navState.hidden;
  };
  ToolbarButton($$payload, spread_props([
    { name, onclick: onclick || toggle },
    restProps,
    {
      class: base({ class: clsx(theme?.base, className) }),
      children: ($$payload2) => {
        Menu($$payload2, { class: menu({ class: clsx(theme?.menu, styling.menu) }) });
      },
      $$slots: { default: true }
    }
  ]));
  pop();
}
function _layout($$payload, $$props) {
  const logo = "/media/branding/officialartisanfair/logo-transparent.webp";
  let { children } = $$props;
  $$payload.out += `<head><base href="/"/></head> `;
  Navbar($$payload, {
    class: "navbar-container",
    breakpoint: "xl",
    children: ($$payload2) => {
      NavBrand($$payload2, {
        href: "/",
        children: ($$payload3) => {
          $$payload3.out += `<img${attr("src", logo)} class="navbar-oaf-logo" alt="Official Artisan Fairs Logo"/>`;
        },
        $$slots: { default: true }
      });
      $$payload2.out += `<!----> `;
      NavHamburger($$payload2, {
        style: "border: 1px black solid; border-radius: 15%; margin-right: 2.5%;"
      });
      $$payload2.out += `<!----> `;
      NavUl($$payload2, {
        children: ($$payload3) => {
          NavLi($$payload3, {
            href: "/events?eventSeries=rosedale-fair",
            class: "navbar-link-container",
            children: ($$payload4) => {
              $$payload4.out += `<!---->Rosedale Fair`;
            },
            $$slots: { default: true }
          });
          $$payload3.out += `<!----> `;
          NavLi($$payload3, {
            href: "/events?eventSeries=night-fair",
            class: "navbar-link-container",
            children: ($$payload4) => {
              $$payload4.out += `<!---->Night Fair`;
            },
            $$slots: { default: true }
          });
          $$payload3.out += `<!----> `;
          NavLi($$payload3, {
            href: "/events?eventSeries=riverwalk-fair",
            class: "navbar-link-container",
            children: ($$payload4) => {
              $$payload4.out += `<!---->Riverwalk Fair`;
            },
            $$slots: { default: true }
          });
          $$payload3.out += `<!----> `;
          NavLi($$payload3, {
            href: "https://forms.office.com/r/TeTUakNSA9",
            class: "navbar-link-container",
            children: ($$payload4) => {
              $$payload4.out += `<!---->Become a Vendor`;
            },
            $$slots: { default: true }
          });
          $$payload3.out += `<!----> `;
          NavLi($$payload3, {
            href: "https://forms.cloud.microsoft/Pages/ResponsePage.aspx?id=DQSIkWdsW0yxEjajBLZtrQAAAAAAAAAAAANAAW3e-axUQThQSVVYVTc0WTk3MlQyM1IxMlJRRjdKSi4u",
            class: "navbar-link-container",
            children: ($$payload4) => {
              $$payload4.out += `<!---->Request an Event`;
            },
            $$slots: { default: true }
          });
          $$payload3.out += `<!---->`;
        },
        $$slots: { default: true }
      });
      $$payload2.out += `<!---->`;
    },
    $$slots: { default: true }
  });
  $$payload.out += `<!----> `;
  children($$payload);
  $$payload.out += `<!---->`;
}
export {
  _layout as default
};
